import { observable, computed, autorun } from 'mobx';
import { solarPosition } from '../sun-calc';
import { scaleLinear, json } from 'd3';
import { compact } from 'lodash';

const autoAdvance = false;
const keyBoardControl = false;

class UiState {
  @observable
  time = new Date();
  @observable
  hourOffset = 0;

  constructor() {
    // debugger
    this.update();
    autoAdvance &&
      setInterval(() => {
        this.hourOffset += 0.5;
      }, 10000);

    setInterval(() => {
      this.loadPlaceInfo();
    }, 60 * 1000);

    keyBoardControl &&
      document.addEventListener('keydown', () => {
        this.hourOffset += 1 / 6;
        this.loadPlaceInfo();
      });

    this.loadPlaceInfo();
  }

  loadPlaceInfo() {
    console.log('load place info');

    // const url = `https://api.opencagedata.com/geocode/v1/json?key=f12a05723809480d9d0f2106b07e81f1&q=${
    //   this.lat
    // },${this.lon}&pretty=1&no_annotations=1`;
    const url = `http://api.mapbox.com/geocoding/v5/mapbox.places/${this.lon},${this.lat}.json?access_token=pk.eyJ1IjoibW9yaXR6c3RlZmFuZXIiLCJhIjoiUGs4LU1VZyJ9.oJh_Gi3geralmUvrJVWYaA`;

    console.log(url);

    json(url).then(d => {
      console.log(d);
      this.placeInfo = d;
    });
  }

  update() {
    const t = new Date();
    if (document.location.hash)
      this.hourOffset = Number(document.location.hash.replace('#', '')) || 0;
    this.time = new Date(t.getTime() + this.hourOffset * 60 * 60 * 1000);
    window.requestAnimationFrame(() => this.update());
  }

  @computed
  get hours() {
    return this.time.getHours();
  }

  @computed
  get minutes() {
    return this.time.getMinutes();
  }

  @computed
  get seconds() {
    return this.time.getSeconds();
  }

  @computed
  get milliseconds() {
    return this.time.getMilliseconds();
  }

  @computed
  get placeString() {
    if (
      this.placeInfo &&
      this.placeInfo.features &&
      this.placeInfo.features.length
    ) {
      console.log(this.placeInfo.features[0].place_name);
      return this.placeInfo.features[0].place_name;
    } else {
      return '';
    }
  }

  zoomSpeed = 5;

  @computed
  get zoom() {
    const zoomScale = scaleLinear()
      .domain([-1, 1])
      .range([8, 12]);
    return zoomScale(
      Math.cos(this.zoomSpeed * 24 * (this.lon / 360) * 2 * Math.PI),
    );
  }

  @computed
  get solPos() {
    return solarPosition(this.time);
  }

  @computed
  get timeZoneString() {
    const hours = -this.time.getTimezoneOffset() / 60;
    return hours > 0 ? 'UTC +' + hours : 'UTC ' + hours;
  }

  @computed
  get dateString() {
    return this.time.toString().replace(/\d\d:\d\d:\d\d/, ' — ');
  }

  @computed
  get lon() {
    let x = this.solPos[0];
    while (x < -180) x += 360;
    while (x > 180) x -= 360;
    return x;
  }

  @computed
  get lat() {
    let x = this.solPos[1];

    while (x < -90) x += 180;
    while (x > 90) x -= 180;
    return x;
  }

  @observable
  placeInfo = null;
}

const uiState = new UiState();
export default uiState;
